﻿export default class ActionRightsControl {
    constructor(options) {
        this.dataItem = options.dataItem;
        this.localization = options.localization;
        this.actionLocalization = options.actionLocalization;
        this.fieldsTreeItem = options.fieldsTreeItem;
        this.fieldsFilterItem = options.fieldsFilterItem;
        this._initControl();
    }

    getData() {
        let treeData = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().toJSON();
        this._serializeTree(treeData);
        return treeData;
    }

    _initControl() {
        this._initTree();
        this._initEvents();
    }

    _initTree() {
        let actionsRightsUrl = rootUrl + 'Role/GetRoleEntityAction?idRole=' + this.dataItem.IdRole + '&idEntity=' + this.dataItem.IdEntity;
        $.ajax({
            type: "GET",
            url: actionsRightsUrl,
            async: true,
            contentType: "application/json; charset=utf-8",
            success: (actions) => {
                this._replaceTypeNames(actions);
                this._normalizeTree(actions);
                this._constructTree(actions);
            },
            error: (e) => {
                toastr.error(this._getResource('GetActionsRightsError'));
            }
        });
    }

    _initEvents() {
        $('#' + this.fieldsFilterItem).on('input', (evt) => {
            this._filterTree();
        });
    }

    _filterTree() {
        let searchFilter = {
            field: "Name",
            operator: "contains",
            value: $('#' + this.fieldsFilterItem).val()
        };

        $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.filter(searchFilter);
        $('.tree-parent-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
    }

    _normalizeTree(items) {        
        items.forEach(item => {
            if (item.Checked == null) {
                item.CanBeChecked = false;
            }

            let childs = [];
            if (item.Actions != null) {
                let childsA = item.Actions;

                childsA.forEach(child => {
                    child.CanBeChecked = true;
                    child.Name = this._normalizeActionName(child.Action);
                    child.IdRole = this.dataItem.IdRole;
                    child.checked = child.Checked;
                    child.type = 'ACTION';
                });

                childs = childs.concat(childsA);
            }
            if (item.Commands != null) {
                let childsA = item.Commands;

                childsA.forEach(child => {
                    child.CanBeChecked = true;
                    child.Name = child.Command.Name;
                    child.IdRole = this.dataItem.IdRole;
                    child.checked = child.Checked;
                    child.type = 'COMMAND';
                });

                childs = childs.concat(childsA);
            }

            if (item.Items != null) {
                let childsA = item.Items;
                this._normalizeTree(childsA);

                childs = childs.concat(childsA);
            }

            item.Items = childs;            
        });
    }

    _serializeTree(items) {
        items.forEach(item => {
            if (item.CanBeChecked != null) {
                delete item.CanBeChecked;
            }

            if (item.Actions != null) {
                for (var i = 0; i < item.Actions.length; i++) {
                    delete item.Actions[i].Name;
                    delete item.Actions[i].CanBeChecked;
                    for (var j = 0; j < item.Items.length; j++) {
                        if (item.Items[j].type == 'ACTION' && item.Items[j].Id == item.Actions[i].Id) {
                            item.Actions[i].Checked = item.Items[j].checked;
                            break;
                        }
                    }
                    
                    delete item.Actions[i].checked;
                }
            }
            if (item.Commands != null) {
                for (var i = 0; i < item.Commands.length; i++) {
                    delete item.Commands[i].Name;
                    delete item.Commands[i].CanBeChecked;
                    for (var j = 0; j < item.Items.length; j++) {
                        if (item.Items[j].type == 'COMMAND' && item.Items[j].Id == item.Commands[i].Id) {
                            item.Commands[i].Checked = item.Items[j].checked;
                            break;
                        }
                    }

                    delete item.Commands[i].checked;
                }
            }

            if (item.Actions != null || item.Commands != null) {
                delete item.Items;
            }
            if (item.Items != null) {
                this._serializeTree(item.Items);
            }
        });
    }

    _normalizeActionName(action) {
        switch (action.Type) {
            case 'STANDARD_GENERAL': return this._getActionResource('GeneralAction_' + action.SubType);
            case 'STANDARD_ELEMENT': return this._getActionResource('ElementAction_' + action.SubType);
            default: return action.Text;
        }
    }

    _constructTree(items) {
        let dataSource = new kendo.data.HierarchicalDataSource({
            data: items, schema: {
                model: {
                    id: "Id",
                    children: "Items"
                }
            }
        });

        $('#' + this.fieldsTreeItem).kendoTreeView({
            template: `<div><span class="field-display-text#= item.CanBeChecked ? " tree-leaf-action" : " tree-parent-action" #">#= item.Name #</span></div>`,
            checkboxes: {
                name: 'Checked'
            },
            loadOnDemand: false,
            dataSource: dataSource,
            dataTextField: "Name",
            dataValueField: "Id"
        });

        $('.tree-parent-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
        $('#' + this.fieldsTreeItem).data('kendoTreeView').expand('.k-treeview-item');
    }

    _replaceTypeNames(items) {
        items.forEach(item => {
            item.Name = this._getResource('ParentTypeConstant_' + item.ParentType);
        });
    }

    _getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }

    _getActionResource(name) {
        if (this.actionLocalization[name] != null && this.actionLocalization[name].trim() != '') {
            return this.actionLocalization[name];
        }

        return name;
    }
}